import { render } from "./ShipButton.vue?vue&type=template&id=4128840c&scoped=true&ts=true"
import script from "./ShipButton.vue?vue&type=script&lang=ts"
export * from "./ShipButton.vue?vue&type=script&lang=ts"

import "./ShipButton.vue?vue&type=style&index=0&id=4128840c&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4128840c"]])

export default __exports__